import script from "./ModalPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPage.vue?vue&type=script&setup=true&lang=ts"

import "./ModalPage.vue?vue&type=style&index=0&id=321271e3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321271e3"]])

export default __exports__